<template>
  <div class="locale-changer">
    <v-select
      v-model="$i18n.locale"
      :items="langs"
      :label="$t('otros.idioma')"
      item-text="text"
      item-value="value"
      @change="onLanguageChange"
    ></v-select>
  </div>
</template>

<script>
export default {
  name: "locale-changer",
  data() {
    return {
      langs: [
        { text: "Español", value: "es" },
        { text: "English", value: "en" },
        { text: "Catalá", value: "ca" }
      ]
    };
  },
  methods: {
    onLanguageChange() {
      window.localStorage.setItem("_locale", this.$i18n.locale);
    }
  }
};
</script>

